import { HmacSHA256 } from "crypto-js";
import { useLocalStorage } from "hooks/use-local-storage";
import { useEffect } from "react";

import { useAuth } from "@/features/auth/shared/hooks/use-auth";

export const useBrowserToken = () => {
  const uuid = crypto?.randomUUID?.() || "";
  const { backendToken } = useAuth();
  const [browserToken, setBrowserToken] = useLocalStorage("browser-token", "");

  useEffect(() => {
    if (browserToken) return;

    // create new browser token with uuid and user agent, hash it with sha256
    const userAgent = navigator.userAgent;
    const hashedBrowserToken = HmacSHA256(userAgent, uuid).toString();
    setBrowserToken(hashedBrowserToken);
  }, [backendToken, browserToken, setBrowserToken, uuid]);

  return { browserToken };
};
